import { getPermissoesProjetos } from "../services/api";
import { PermissoesProjetos } from "../interfaces";

const CACHE_KEY = "permissao_projeto";
const CACHE_TTL = 60 * 60 * 1000; // 1 hora

export async function getCachedPermissao(): Promise<PermissoesProjetos | null> {
  const cached = localStorage.getItem(CACHE_KEY);

  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      const expired = Date.now() - parsed.timestamp > CACHE_TTL;

      if (!expired && parsed.permissao) {
        return parsed.permissao as PermissoesProjetos;
      }
    } catch {
    }
  }

  try {
    const permissoes = await getPermissoesProjetos();
    if (permissoes) {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ permissao: permissoes, timestamp: Date.now() })
      );
      return permissoes;
    }
  } catch (e) {
    console.error("Erro ao buscar permissões:", e);
  }

  return null;
}

export function clearCachedPermissao() {
  localStorage.removeItem(CACHE_KEY);
}
